import React from "react";
import DividerCustom from "./DividerCustom";
import theme from "../../../theme";
import { useMediaQuery } from "@mui/material";

type Props = {
  height?: string;
  paddingTop?: string;
  zIndex?: number;
};

const DividerContainer = ({ height, paddingTop, zIndex }: Props) => {
  const isSmScreen = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <>
      {" "}
      <DividerCustom
        zIndex={zIndex}
        rightPosition={isSmScreen ? "5%" : "25%"}
        height={height || "800vh"}
      />
      {/* <DividerCustom
        zIndex={zIndex}
        rightPosition={"50%"}
        height={height || "800vh"}
      /> */}
      <DividerCustom
        zIndex={zIndex}
        rightPosition={isSmScreen ? "95%" : "75%"}
        height={height || "800vh"}
      />
    </>
  );
};

export default DividerContainer;
